import { render, staticRenderFns } from "./CloseTurn.vue?vue&type=template&id=5a6a6bdc&scoped=true"
import script from "./CloseTurn.vue?vue&type=script&lang=js"
export * from "./CloseTurn.vue?vue&type=script&lang=js"
import style0 from "./CloseTurn.vue?vue&type=style&index=0&id=5a6a6bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a6bdc",
  null
  
)

export default component.exports